import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IVendorCompanyMast } from "../../models/VendorCompanyMast";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { EmptyVendorCompany } from "./EmptyVendorCompany";
import { IModel } from "./VendorCompanyMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { CompanyAccountsDetails } from "./CompanyAccountsDetails";
import { Dialog } from "primereact/dialog";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVendorCompanyMast>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [openAccout, setOpenAccout] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IVendorCompanyMast });
    const [historyTable, setHistoryTable] = useState({ vendor_Company_ID: null, open: false } as { vendor_Company_ID: any, open: boolean });
    const [historytableData, setHistorytableData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>, loading: boolean });
    const dt = useRef<any>(null);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'vendor_Company_ID',
        sortOrder: -1
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const getTableDataCount = async () => {
        const response = await Fetch("Vendor_Company_Mast/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Vendor_Company_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IVendorCompanyMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyVendorCompany });
    };


    const openEdit = (rowDatauser: IVendorCompanyMast) => {
        rowDatauser.city = {
            city_ID: rowDatauser?.city_ID ? rowDatauser?.city_ID : 0,
            city_Name: rowDatauser?.city_Name ? rowDatauser?.city_Name : ''
        }
        rowDatauser.state = {
            state_ID: rowDatauser?.state_ID ? rowDatauser?.state_ID : 0,
            state_Name: rowDatauser?.state_Name ? rowDatauser?.state_Name : ''
        }
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const openAccounts = (rowDatauser: IVendorCompanyMast) => {
        setOpenAccout({ open: true, singleData: rowDatauser });
    };
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Client Company</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const website_URL = (rowData: IVendorCompanyMast) => {
        return (
            rowData.website_URL && <a target="_blank" href={rowData.website_URL}>{rowData.website_URL}</a>
        );
    };

    const closeAccountsModal = () => {
        setOpenAccout({ open: false, singleData: { vendor_Type_Name: "" } });
    }

    const loadTableData1 = async (vendor_Company_ID?: number) => {
        setHistorytableData({ historytableData: historytableData.historytableData, loading: true });
        const response = await Fetch("Vendor_Company_Mast/PvcategoryHistory", "GET", null, `vendor_Company_ID=${vendor_Company_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setHistorytableData({ historytableData: data, loading: false });
        } else {
            setHistorytableData({ historytableData: historytableData.historytableData, loading: false });
        }
    }
    const actionBodyTemplate = (rowData: IVendorCompanyMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                {/* <Button icon="pi pi-user" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openAccounts(rowData)} /> */}
                <Button icon="pi pi-history" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { loadTableData1(rowData.vendor_Company_ID); setHistoryTable({ vendor_Company_ID: rowData.vendor_Company_ID, open: true }) }} />

            </div>
        );
    };

    const toggleVal = async (vendor_Company_ID: number | IVendorCompanyMast, toggle_type: number) => {
        const response = await Fetch("Vendor_Company_Mast/togglestatus", "PUT", null, `vendor_Company_ID=${vendor_Company_ID}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to Enable/Disable Share PV`,
            header: 'Confirm ',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => toggleVal(rowData.vendor_Company_ID, 1),
            reject: () => rejectFunc()
        });
    }

    const vendor_TStatus = (rowData: any) => {
        return ((_roles.includes(1) || _roles.includes(26)) ?
            <span style={{ color: rowData.disable_Share_PV ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { confirmDelete(rowData); }}>{rowData.disable_Share_PV ? "Yes" : "No"}</span> :
            <span style={{ color: rowData.disable_Share_PV ? 'green' : 'red' }} className="cursor-pointer" >{rowData.disable_Share_PV ? "Yes" : "No"}</span>
        )

    };

    const pDate1 = (rowData: any) => {
        let date;
        if (rowData.updatedOn) date = format(new Date(rowData.updatedOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHideHistoryTable = () => {
        setHistoryTable({ vendor_Company_ID: 0, open: false });
    }


    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Company found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="vendor_Company_Name" header="Company Name" sortable />
                <Column field="vendor_Company_FidNo" header="FID#" sortable />
                <Column field="vendor_Company_Phone" header="Phone No." />
                <Column field="vendor_Company_FaxNo" header="Fax No." sortable />
                <Column field="vendor_Type_Name" header="Vendor Type" sortable />
                <Column field="city_Name" header="City" sortable />
                <Column field="state_Name" header="State Name" sortable />
                <Column field="major_Technology" header="Major Technology" sortable />
                <Column field="website_URL" header="Website Url" body={website_URL} />
                <Column field="disable_Share_PV" header="Disable Share PV" sortable body={vendor_TStatus} />

                <Column body={actionBodyTemplate} />
            </DataTable>
            <Dialog visible={historyTable.open} style={{ width: '80vw' }} header="Hold/UnHold History" modal className="p-fluid" onHide={onHideHistoryTable} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No Branches found."
                    loading={historytableData.loading}
                    value={historytableData.historytableData}
                >
                    <Column field="old_Category" header="Old Category" />
                    <Column field="new_Category" header="New Category" />

                    <Column field="updatedBy" header="Updated By" />
                    <Column field="Updated On" header="Date" body={pDate1} />
                </DataTable>
            </Dialog>
            <CompanyAccountsDetails open={openAccout.open} onHide={closeAccountsModal} singleData={openAccout.singleData} toast={props.toast} />
            <ConfirmDialog />
        </>
    );
}
